import { t } from '../../app/i18n';

export default {
  INACTIVE: 'INACTIVE',
  EMAIL_CONFIRMED: 'EMAIL_CONFIRMED',
  PROFILE_COMPLETE: 'PROFILE_COMPLETE',
  DOCUMENTS_SUBMITTED: 'DOCUMENTS_SUBMITTED',
  DOCUMENTS_ACCEPTED: 'DOCUMENTS_ACCEPTED',
  CONTRACT_SIGNED: 'CONTRACT_SIGNED',
  ACCOUNT_ACTIVE: 'ACCOUNT_ACTIVE',
  NEW_GENERAL_CONTRACT: 'NEW_GENERAL_CONTRACT',
  DOCUMENTS_REJECTED: 'DOCUMENTS_REJECTED',
  DOCUMENTS_INCORRECT: 'DOCUMENTS_INCORRECT',
  PRESCORING_FAILED: 'PRESCORING_FAILED',
  BANK_ACCOUNT_STATEMENTS_UPLOADED: 'BANK_ACCOUNT_STATEMENTS_UPLOADED',
};

export const translation = {
  INACTIVE: t('Neaktívny'),
  EMAIL_CONFIRMED: t('Potvrdený e-mail'),
  PROFILE_COMPLETE: t('Nevyplnený profil'),
  DOCUMENTS_SUBMITTED: t('Odoslané dokumenty'),
  DOCUMENTS_ACCEPTED: t('Schválené dokumenty'),
  CONTRACT_SIGNED: t('Zmluva podpísaná'),
  ACCOUNT_ACTIVE: t('Aktívny'),
  NEW_GENERAL_CONTRACT: t('Nová rámcová zmluva'),
  DOCUMENTS_REJECTED: t('Dokumenty zamietnuté'),
  DOCUMENTS_INCORRECT: t('Chybný OP'),
  PRESCORING_FAILED: t('Prescoring zlyhal'),
  BANK_ACCOUNT_STATEMENTS_UPLOADED: t('Výpisy z účtu nahrané'),
};



// WEBPACK FOOTER //
// ./src/common/enums/accountRegistrationStatuses.js